'use client';

import { PropsWithChildren } from 'react';
import cx from 'classnames';

import { Button, IButtonProps } from '@/src/components/ui/button';

type IHeaderButtonProps = PropsWithChildren & {
  className?: IButtonProps['className'];
  linkToPlayStore: string;
  linkToAppStore: string;
  text: string | null;
};

export const HeaderDownload = ({
  className,
  linkToPlayStore,
  linkToAppStore,
  text,
}: IHeaderButtonProps) => {
  const onClick = () => {
    const userAgent = window.navigator.userAgent;
    let link = linkToPlayStore;

    if (userAgent.includes('Mac') || /iPhone|iPad|iPod/.test(userAgent)) {
      link = linkToAppStore;
      window.dataLayer?.push({
        event: 'click_app_download',
        app_version: 'AppStore',
      });
    } else {
      window.dataLayer?.push({
        event: 'click_app_download',
        app_version: 'PlayStore',
      });
    }

    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button
      variant={'outlineTransparent'}
      size={'sm'}
      className={cx(
        'font-semibold lg:mx-auto px-4 py-2.5 xl:px-6 xl:py-4',
        className
      )}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
